import { LOADER_STATUS, COMPANIES_DATA, TOTAL_RECORD, GET_ALL_GROUPS, REGION_LIST, DEPARTMENT_LIST } from './constants';
export const initialState = {
    loaderStatus: false,
    companies: [],
    totalRecords: '',
    records: '',
    groups: [],
    departmentList: [],
    regionList: []
};
const managePartnerReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOADER_STATUS:
            return {
                ...state,
                loaderStatus: action.loaderStatus
            }
        case COMPANIES_DATA:
            return {
                ...state,
                companies: action.payload
            }
        case TOTAL_RECORD:
            return {
                ...state,
                totalRecords: action.totalRecords,
                records: action.records
            }
        case GET_ALL_GROUPS:
            return {
                ...state,
                groups: action.payload
            }
        case REGION_LIST: {
            return {
                ...state,
                regionList: action.payload
            }
        }
        case DEPARTMENT_LIST: {
            return {
                ...state,
                departmentList: action.payload
            }
        }
        default:
            return state;
    }
}


export default managePartnerReducer;